import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AutoFocusModule } from 'primeng/autofocus';
import { KeyFilterModule } from 'primeng/keyfilter';
import { IconModule } from 'src/components/icon/icon.module';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-input-number',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true,
    },
  ],
  styles: [
    `
      ::ng-deep app-input-number {
        .p-inputtext {
          background: transparent;
          border-radius: 0;
          border: none;
          width: 100%;
          color: var(--text-default);
          font-size: 0.875rem;
          padding-left: 0.5rem;

          &::placeholder {
            font-size: 0.875rem;
            color: var(--text-subtler);
            font-weight: 400;
          }
        }
        .p-inputnumber:enabled:focus {
          box-shadow: none;
        }
      }
    `,
  ],
  imports: [
    CommonModule,
    AutoFocusModule,
    FormsModule,
    IconModule,
    KeyFilterModule,
    InputNumberModule,
  ],
  templateUrl: './input-number.component.html',
})
export class InputNumberComponent implements ControlValueAccessor {
  @ViewChild('Input')
  Input?: ElementRef<HTMLInputElement>;

  @Input()
  label?: string;

  @Input()
  labelTemplate?: TemplateRef<any>;

  @Input()
  placeholder: string = 'Masukkan teks';

  @Input()
  error: string | boolean = false;

  @Input()
  styleClass: string = '';

  @Input()
  inputStyleClass: string = '';

  //   @Input()
  //   enterable: boolean = false

  @Input()
  readonly: boolean = false;

  @Input()
  autofocus: boolean = false;

  @Input()
  min?: number;

  @Input()
  max?: number;

  @Input()
  maxlength: number | null = null;

  @Input()
  useGrouping: boolean = true;

  @Output()
  enter = new EventEmitter<void>();

  @Input()
  disabled: boolean = false;

  _value: any = '';
  private _lastValid: any = '';
  onChange: (value: any) => void = () => {};
  onTouched: (value: any) => void = () => {};

  set value(value: any) {
    this._value = value;
    this.onChange(value);
    this.onTouched(value);
  }
  get value() {
    return this._value;
  }

  constructor() {}

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: any) => void): void {
    this.onTouched = fn;
  }

  //   handleKeypress(e: KeyboardEvent) {
  //     if (e.key === 'Enter' && this.enterable) {
  //       this.enter.emit()
  //     }
  //   }
}
